import { getHubCachedAccessToken } from "@/lib/hubAuthAccessToken";

/**
 * Bearer header mirrored by AuthProvider.
 *
 * Do not fall back to supabase.auth.getSession() here. Concurrent callers can queue
 * behind Supabase's cross-tab session lock and delay application startup.
 */
export function hubApiAuthHeader(): Record<string, string> {
  const cached = getHubCachedAccessToken();
  if (cached != null && cached !== "") {
    return { Authorization: `Bearer ${cached}` };
  }
  return {};
}
